import { ApiError } from './apiClient';
import { API_BASE_URL } from '../config/urls';

interface UploadImageResponse {
    success: boolean;
    url: string;
    key: string;
    size: number;
}

export const imagingApi = {
    async uploadImage(file: File): Promise<string> {
        const sessionToken = localStorage.getItem('sessionToken');
        
        if (!sessionToken) {
            throw new ApiError(401, 'No session token found');
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('contentType', file.type);

        try {
            const response = await fetch(`${API_BASE_URL}/api/images/upload`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionToken}`
                },
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Upload failed' }));
                throw new ApiError(response.status, errorData.error || 'Upload failed');
            }

            const data = await response.json();

            if (!data.success || !data.data?.url) {
                throw new ApiError(500, 'Invalid response from server');
            }

            return data.data.url;
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(500, 'Failed to upload image');
        }
    }
};

